"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundTo = void 0;
var roundTo = function (number, precision) {
    var factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
};
exports.roundTo = roundTo;
//# sourceMappingURL=number-utils.js.map